import React from 'react';
import AddWorkerWizard from './components/AddWorkerWizard/AddWorkerWizard';

export default function AddWorker() {
  return <AddWorkerWizard />;
}
